import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import {
  createAnswerItemsFromValues,
  getAnswerValuesFromItems
} from 'components/Assessments/helpers'
import {
  AdapterOptions,
  FlatAnswerMutation,
  SectionAdapter
} from 'components/Assessments/adapters/types'
import { ADLNeedFormDataItem } from './formData'
import { ADLNeedQuestionnaireItem } from './questionnaire'
import { RocFormData } from '../../types/RocFormData'
import { RocFormField } from '../../types/RocFormField'
import { RocAssessmentQuestionnaireItem } from '../../types/questionnaire'

export class ADLNeedsSectionAdapter extends SectionAdapter<RocFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    _options?: AdapterOptions
  ): Partial<RocFormData> {
    const adlNeedsAnswers = flatAnswers[ADLNeedQuestionnaireItem.ADL_NEEDS_NEED]?.answer ?? []
    const adlneedsFormData = adlNeedsAnswers?.map<ADLNeedFormDataItem>((adlAnswerItem) => {
      const adlInfoItem = adlAnswerItem.item ?? []

      const adlId = getAnswerValuesFromItems(
        adlInfoItem,
        RocAssessmentQuestionnaireItem.ADL_NEEDS_NEED_ID
      )?.at(0)

      const adlName = getAnswerValuesFromItems(
        adlInfoItem,
        RocAssessmentQuestionnaireItem.ADL_NEEDS_NEED_NAME
      )?.at(0)

      const adlObservationReference = getAnswerValuesFromItems(
        adlInfoItem,
        RocAssessmentQuestionnaireItem.ADL_NEEDS_NEED_OBSERVATION_REFERENCE
      )?.at(0)

      const adlNewNote = getAnswerValuesFromItems(
        adlInfoItem,
        RocAssessmentQuestionnaireItem.ADL_NEEDS_NEED_NEW_NOTE
      )?.at(0)

      const adlIsArchived = getAnswerValuesFromItems(
        adlInfoItem,
        RocAssessmentQuestionnaireItem.ADL_NEEDS_NEED_IS_ARCHIVED
      )?.at(0)

      const adlLastNoteText = getAnswerValuesFromItems(
        adlInfoItem,
        RocAssessmentQuestionnaireItem.ADL_NEEDS_NEED_LAST_NOTE_TEXT
      )?.at(0)

      const adlLastNoteAuthor = getAnswerValuesFromItems(
        adlInfoItem,
        RocAssessmentQuestionnaireItem.ADL_NEEDS_NEED_LAST_NOTE_AUTHOR
      )?.at(0)

      const adlLastNoteDate = getAnswerValuesFromItems(
        adlInfoItem,
        RocAssessmentQuestionnaireItem.ADL_NEEDS_NEED_LAST_NOTE_DATE
      )?.at(0)

      return {
        [RocFormField.ADL_NEED_ID]: adlId,
        [RocFormField.ADL_NEED_NAME]: adlName,
        [RocFormField.ADL_NEED_OBSERVATION_REFERENCE]: adlObservationReference
          ? adlObservationReference.reference
          : undefined,
        [RocFormField.ADL_NEED_NEW_NOTE]: adlNewNote,
        [RocFormField.ADL_NEED_IS_ARCHIVED]: adlIsArchived,
        [RocFormField.ADL_NEED_LAST_NOTE_TEXT]: adlLastNoteText,
        [RocFormField.ADL_NEED_LAST_NOTE_AUTHOR]: adlLastNoteAuthor,
        [RocFormField.ADL_NEED_LAST_NOTE_DATE]: adlLastNoteDate
      }
    })

    return {
      [RocFormField.ADL_NEEDS]: adlneedsFormData
    }
  }
  buildFlatAnswers(formData: RocFormData): FlatAnswerMutation[] {
    const mutations: FlatAnswerMutation[] = []
    if (formData[RocFormField.ADL_NEEDS]) {
      const adlItemsAndValue = formData[RocFormField.ADL_NEEDS]?.map((formData) => {
        const observationReference = formData[RocFormField.ADL_NEED_OBSERVATION_REFERENCE]
        return {
          item: createAnswerItemsFromValues([
            [ADLNeedQuestionnaireItem.ADL_NEEDS_NEED_ID, formData[RocFormField.ADL_NEED_ID]],
            [
              ADLNeedQuestionnaireItem.ADL_NEEDS_NEED_OBSERVATION_REFERENCE,
              observationReference ? { reference: observationReference } : undefined
            ],
            [ADLNeedQuestionnaireItem.ADL_NEEDS_NEED_NAME, formData[RocFormField.ADL_NEED_NAME]],
            [
              ADLNeedQuestionnaireItem.ADL_NEEDS_NEED_NEW_NOTE,
              formData[RocFormField.ADL_NEED_NEW_NOTE]
            ],
            [
              ADLNeedQuestionnaireItem.ADL_NEEDS_NEED_IS_ARCHIVED,
              formData[RocFormField.ADL_NEED_IS_ARCHIVED]
            ],
            [
              ADLNeedQuestionnaireItem.ADL_NEEDS_NEED_LAST_NOTE_TEXT,
              formData[RocFormField.ADL_NEED_LAST_NOTE_TEXT]
            ],
            [
              ADLNeedQuestionnaireItem.ADL_NEEDS_NEED_LAST_NOTE_AUTHOR,
              formData[RocFormField.ADL_NEED_LAST_NOTE_AUTHOR]
            ],
            [
              ADLNeedQuestionnaireItem.ADL_NEEDS_NEED_LAST_NOTE_DATE,
              formData[RocFormField.ADL_NEED_LAST_NOTE_DATE]
            ]
          ])
        }
      })
      mutations.push({
        linkId: ADLNeedQuestionnaireItem.ADL_NEEDS_NEED,
        value: adlItemsAndValue ?? []
      })
    }

    return mutations
  }
}
